import { Autocomplete, TextField } from '@mui/material';
import { useFormikContext } from 'formik';
import { every, find, isArray } from 'lodash';

// Components
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';
import PaperSelect from 'src/components/common/PaperSelect';
import { useQueryParams } from 'src/hooks/useQueryParam';
import { TYPE_CONTRIBUTE, TypeContributeCompany } from 'src/features/CompanyDetail/Common/config';
import { getFormItemError, renderFormItemError } from 'src/utils/helpers/renderFormItemError';
import { TYPE_CONTRIBUTE_PEOPLE } from 'src/features/PeopleDetail/Common/config';
import { ContributeTypes } from 'src/features/Contributions/config';

const FormItemTypeContribution = () => {
  const query = useQueryParams();
  const formik = useFormikContext<ExpectedAny>();
  let listTypeContribute: Array<ExpectedAny> = [];

  switch (query.tab) {
    case ContributeTypes.Company:
      listTypeContribute = TYPE_CONTRIBUTE.filter(
        (type) => type.value !== TypeContributeCompany.ReportWrongOtherContact,
      );
      break;
    case ContributeTypes.ReportWrong:
      listTypeContribute = TYPE_CONTRIBUTE.filter(
        (type) => type.value === TypeContributeCompany.ReportWrongOtherContact,
      );
      break;
    case ContributeTypes.People:
      listTypeContribute = TYPE_CONTRIBUTE_PEOPLE;
      break;
    default:
      listTypeContribute = TYPE_CONTRIBUTE.filter(
        (type) => type.value !== TypeContributeCompany.ReportWrongOtherContact,
      );
      break;
  }

  const getType = (type: string) => {
    const typeItem = find(listTypeContribute, (o) => o.value === type);
    if (!typeItem) {
      return null;
    }
    return typeItem;
  };

  const getValue = () => {
    if (isArray(formik.values.type) && every(formik.values.type, (type) => typeof type === 'string')) {
      return formik.values.type
        .map((type: string) => {
          return getType(type);
        })
        .filter((type: ExpectedAny) => type !== null);
    }
    return formik.values.type;
  };

  return (
    <Autocomplete
      value={getValue()}
      multiple={true}
      size="small"
      fullWidth
      onBlur={formik.handleBlur}
      getOptionKey={(option) => option.optionLabel}
      options={getArrayDefault(listTypeContribute)}
      PaperComponent={PaperSelect}
      onChange={(_, value) => {
        formik.setFieldValue(
          'type',
          value.map((type) => type.value),
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          error={Boolean(getFormItemError('type', formik))}
          helperText={renderFormItemError(getFormItemError('type', formik))}
          id="type"
          name="type"
          placeholder="Search"
          InputLabelProps={{ required: true }}
          label={<span>Filter By Types of Contribute</span>}
        />
      )}
    />
  );
};

export default FormItemTypeContribution;
